class ECXProductRating extends ECXCustomComponent {
  connectedCallback() {
    const ratingElement = this.$(".js-rating");
    const ratingCountElement = this.$(".js-rating-count");
    const ratingValueElement = this.$(".js-rating-value");
    const ratingStarElement = this.$(".js-rating-star");

    ratingElement.style.opacity = "0";

    const ratingCountApp = ratingElement.querySelector("[data-number-of-reviews]");
    const ratingValueApp = ratingElement.querySelector("[data-average-rating]");

    let numberOfReviews = 0;
    let ratingValue = 0;
    let ratingDecimal = 0;

    if (ratingCountApp) {
      numberOfReviews = parseInt(ratingCountApp.dataset.numberOfReviews, 10) || 0;
      if (numberOfReviews > 1) {
        ratingCountElement.innerHTML = `(${numberOfReviews} ${ECXLanguage.product.PRODUCT_REVIEWS})`;
      } else {
        ratingCountElement.innerHTML = `(${numberOfReviews} ${ECXLanguage.product.PRODUCT_REVIEW})`;
      }
    }

    if (ratingValueApp) {
      ratingValue = parseFloat(ratingValueApp.dataset.averageRating, 10) || 0;
      if (!Shopify.designMode) {
        this.classList.toggle("d-none", ratingValue === 0);
      }
      ratingValueElement.textContent = ratingValue;

      const decimal = ratingValue % 1;
      if (decimal >= 0.3 && decimal <= 0.7) {
        ratingDecimal = 0.5;
      } else if (decimal > 0.7) {
        ratingDecimal = 1;
      }

      if (ratingStarElement) {
        ratingStarElement.style.setProperty("--rating", Math.floor(ratingValue));
        ratingStarElement.style.setProperty("--rating-decimal", ratingDecimal);
      }
    }

    requestAnimationFrame(() => {
      ratingElement.style.opacity = "1";
      ratingElement.style.transition = "opacity 0.3s ease-in-out";
    });
  }
}

customElements.define("ecx-product-rating", ECXProductRating);